/*
 *
 * Leads sagas
 *
 */

import { takeLatest, put, call } from 'redux-saga/effects';

import * as services from './services';
import Creators, { LeadsTypes as constants } from './reducer';

const actions = {
  getLeadsActions: {
    request: Creators.getLeadsRequest,
    success: Creators.getLeadsSuccess,
    errors: Creators.getLeadsFailure,
  },
  sendSelectedActions: {
    request: Creators.sendSelectedDataRequest,
    success: Creators.sendSelectedDataSuccess,
    errors: Creators.sendSelectedDataFailure,
  },
  sendTaskActions: {
    request: Creators.sendTaskRequest,
    success: Creators.sendTaskSuccess,
    errors: Creators.sendTaskFailure,
  },
  getCitiesListAdminActions: {
    request: Creators.getCitiesListAdminRequest,
    success: Creators.getCitiesListAdminSuccess,
    errors: Creators.getCitiesListAdminFailure,
  },
};

const eventsOptions = {
  [constants.GET_LEADS_REQUEST]: {
    api: services.getLeads,
    actions: actions.getLeadsActions,
  },
  [constants.SEND_SELECTED_DATA_REQUEST]: {
    api: services.sendSelectedData,
    actions: actions.sendSelectedActions,
  },
  [constants.SEND_TASK_REQUEST]: {
    api: services.sendTask,
    actions: actions.sendTaskActions,
  },
  [constants.GET_CITIES_LIST_ADMIN_REQUEST]: {
    api: services.getCitiesListAdmin,
    actions: actions.getCitiesListAdminActions,
  },
};

function* apiGenerator(action) {
  const provider = eventsOptions[action.type];

  try {
    const params = action.payload;
    const response = yield call(provider.api, params);

    if (response.ok && response.data) {
      yield put(provider.actions.success(response.data));
    } else {
      yield put(provider.actions.errors({ errors: 'some error' }));
    }
  } catch (errors) {
    yield put(provider.actions.errors({ errors }));
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_LEADS_REQUEST, apiGenerator);
  yield takeLatest(constants.SEND_TASK_REQUEST, apiGenerator);
  yield takeLatest(constants.SEND_SELECTED_DATA_REQUEST, apiGenerator);
  yield takeLatest(constants.GET_CITIES_LIST_ADMIN_REQUEST, apiGenerator);
}
